/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  OrderReturnModel,
  ValidationErrorResponse,
} from '../models/index';
import {
    OrderReturnModelFromJSON,
    OrderReturnModelToJSON,
    ValidationErrorResponseFromJSON,
    ValidationErrorResponseToJSON,
} from '../models/index';
import { HandleRequest } from '../../handle-request'
export type GetOrderRequest = {
    orderId: string;
    skipTracking?: boolean;
}



/**
 * 
 */
export class OrderApi extends runtime.BaseAPI {


    /**
     */
     getOrder = HandleRequest.Handle<GetOrderRequest,OrderReturnModel>('OrderApi_getOrder',async (requestParameters: GetOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderReturnModel>>  => {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling getOrder().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['skipTracking'] != null) {
            queryParameters['skipTracking'] = requestParameters['skipTracking'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        let response = null;


         response = await this.request({
            path: `/api/order/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderReturnModelFromJSON(jsonValue));
    })

    /**
     */


}
